// extracted by mini-css-extract-plugin
export default {"wrapper":"ContactPage_wrapper__D2oQi","head":"ContactPage_head__B8IQK","link":"ContactPage_link__E7uCK","heading":"ContactPage_heading__mJJ42","text":"ContactPage_text__dcDWe"};